module.exports = __webpack_public_path__ + "img/qreg.9fbc2c4c.png";